import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css'
import 'jquery-datetimepicker';

// Eksportowanie funkcji inicjalizującej zdarzenia
export default function workshop() {
  // Inicjalizacja Select2 na elemencie #workshop_requirement_ids
  $('#workshop_requirement_ids').select2();

  // TODO - to jest gdzies uzywane?
  // Obsługa zdarzenia zmiany na checkboxie #select_all
  $('#select_all').change(function() {
    const checkboxes = $(this).closest('div.panel').find(':checkbox');
    if ($(this).is(':checked')) {
      checkboxes.prop('checked', true);
    } else {
      checkboxes.prop('checked', false);
    }
  });

  // Obsługa zdarzenia zmiany na select #workshop_workshop_category_id
  $('#workshop_workshop_category_id').change( function() {
    const selectedId = $(this).val() || 0;
    $.getJSON(`/workshop_categories/${selectedId}`, workshop_category_callback);
  });

  // Inicjalizacja datetimepicker na #workshop_release_date z callbackiem onShow
  $('#workshop_release_date').datetimepicker({
    onShow: (container) => {
      const publishDate = $('#workshop_publish_date').val();
      parseDateFromPolishFormat(publishDate, '#workshop_release_date');
    }
  });

  // Inicjalizacja datetimepicker na #workshop_start_date z callbackiem onShow
  $('#workshop_start_date').datetimepicker({
    onShow: function(container) {
      const releaseDate = $('#workshop_release_date').val();
      parseDateFromPolishFormat(releaseDate, '#workshop_start_date');
    }
  });

  // Inicjalizacja datetimepicker na #workshop_end_date z callbackiem onShow
  $('#workshop_end_date').datetimepicker({
    onShow: function(container) {
      const startDate = $('#workshop_start_date').val();
      parseDateFromPolishFormat(startDate, '#workshop_end_date');
    }
  });
}

// Callback funkcji dla AJAX requestu kategorii warsztatu
function workshop_category_callback(data) {
  $('#workshop_name').val(data.name);
  $('#workshop_description').val(data.description);
  $('#workshop_price').val(data.price);
  $('#workshop_min_attendees').val(data.min_attendees);
  $('#workshop_max_attendees').val(data.max_attendees);
  $('#workshop_meetings_count').val(data.meetings_count);
  $('#workshop_requirement_ids').val([]).trigger('change');
  $('#workshop_requirement_ids').select2().val(data.requirements).trigger('change');
}

  // Funkcja do parsowania daty z formatu polskiego i inicjalizacji datetimepicker
function parseDateFromPolishFormat(dateToParse, container) {
  if (dateToParse !== '__.__.____ __:__') {
    const dateParts = dateToParse.split(' ');
    const date = dateParts[0].split('.');
    const time = dateParts[1].split(':');
    const dateToSet = new Date(
      parseInt(date[2], 10),
      parseInt(date[1], 10) - 1,
      parseInt(date[0], 10),
      parseInt(time[0], 10),
      parseInt(time[1], 10),
      0,
      0
    );
    $(container).datetimepicker({
      minDate: new Date(dateToSet)
    });
  }
}
